<!--  -->
<template>
    <div class=''>
        <Modal v-model="modal" title="删除" width="660px" @on-ok="onDelete" @on-cancel="onCancel">
            <div class="wrapper">
                <div class="notice">{{message}}</div>
                <!-- 搜索输入框 -->
                <div class="tr box">
                    <div class="tr_title">姓名</div>
                    <Input
                        class="add-input"
                        placeholder="请输入.."
                        size="large"
                        type="text"
                        search
                        enter-button="搜索"
                        v-model="searchValue"
                        @on-search="onSearch"
                    />
                </div>
                <div class="loading" v-if="isLoading">
                    <Spin fix>
                        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                        <div>加载中..</div>
                    </Spin>
                </div>
                <!-- 没有搜索结果提示 -->
                <div class="nolist" v-if="!isLoading && noSearchResult">未搜索到该用户。</div>
                <!-- 搜索结果列表 -->
                <div class="search-list" v-if="!isLoading && searchResList.length">
                    <!-- 结果类目 -->
                    <div
                        class="search-item"
                        :class="{select:item.select}"
                        @click="onSelect(index)"
                        v-for="(item,index) in searchResList"
                        :key="item.id"
                    >
                        <!-- 头像 -->
                        <img
                            class="search-avatar"
                            v-lazy="item.headPicUrl || require('@/assets/images/default.png')"
                        >
                        <!-- 名字 -->
                        <span class="search-name">{{item.realName}}</span>
                        <span class="user-name">{{item.userName}}</span>
                    </div>
                </div>
            </div>
        
        </Modal>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            searchValue:'',
            searchSelectId:'',
            noSearchResult:false,
            isLoading:false,//加载中
            searchResList:[],//搜索结果列表
        };
    },
     props: {
        // 弹窗的配置项
        modal: {
            type: Boolean,
            default:false,
        },
        api:{
            type:String,
            default(){
                return this.urlobj.getPerson
            },
        },
        params:{
            type:Object,
            default(){
                return {}
            },
        },
        message:{
            type:String,
            default(){
                return ''
            },
        },
        deleteUnionid:{
            type:String,
            default(){
                return ''
            },
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getPeople(searchValue) {
            this.isLoading = true
            this.searchResList = []
            var url = this.api;
            this.params.residentName = searchValue
            let data = {
                 pageNum: 0,
                pageSize: 0,
                ...this.params
            }
           console.log(this.params)
            this.$post(url, data).then(res => {
                
                this.searchResList = res.rows.filter(item=>item.unionId != this.deleteUnionid)
                                            .map(item=>{
                                            console.log(this.searchSelectId)
                                                return {
                                                    id:item.uId,
                                                    unionId:item.unionId,
                                                    select:this.searchSelectId==item.uId?true:false, // 是否被选中 id是否出现在被选中的列表里,
                                                    userName:item.userName || item.workerName,
                                                    realName:item.realName?item.realName:'暂无姓名',
                                                    name:(item.realName?item.realName:'暂无姓名')+'('+item.userName+')',
                                                    headPicUrl:item.headPicUrl,
                                                }
                                            })
                
                this.isLoading = false
            }).catch(e => {
                this.isLoading = false
                console.log(e)
            });
        },
        onSearch(){
            this.getPeople(this.searchValue)
        },
        onSelect(index){
            this.searchResList[index].select = !this.searchResList[index].select
            let item = this.searchResList[index];
            if(item.select){
                //如果没选中，则选中
                this.searchSelectId = item.unionId
            }else{
                 this.searchSelectId = ""
            }
        },
        onCancel(){
            this.$emit('onCancel')
        },
        onDelete(){
            this.$emit('onDelete',this.searchSelectId)
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getPeople();
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
@mainColor: #ff7b44;
/* 搜索结果列表 */
.noIEBar {
  // ie 10 11 12
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;
}
.notice{
    color:#d22b2b;
    font-size: 14px;
    margin-bottom:15px;
}
.tr{
    line-height: 36px;
    .tr_title{
        margin-right: 20px;
        width: 45px;
    }
}
.nolist {
  flex: 1;
  font-size: 12px;
  color: #d22b2b;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-list {
  flex: 1;
  padding-top: 10px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: scroll;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap:30px;
  align-content: start;
  // chrome
//   &::-webkit-scrollbar {
//     display: none;
//   }
//   .noIEBar;
   &::-webkit-scrollbar {
        width: 2px;
        height: 2px;
        background-color: #fff;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #fff;
    }
    &::-webkit-scrollbar-thumb {
        height: 20px;
        border-radius: 10px;
        background-color: #ccc;
    }
}
.search-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 150px;
  border: 1px solid #eee;
  border-radius: 8px;
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  }
}
.select {
  border-color: @mainColor;
}
.select:after {
  content: "";
  position: absolute;
  right: -10px;
  top: -10px;
  z-index: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: @mainColor;
}
.select:before {
  content: "";
  position: absolute;
  right: -3px;
  top: -6px;
  z-index: 1;
  width: 6px;
  height: 10px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  transform: rotateZ(45deg);
}
.search-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 30px;
  margin-bottom: 20px;
}
.search-name {
  font-size: 14px;
  color: #444;
}
.user-name{
    font-size: 10px;
    color:#999
}
.wrapper{
    height: 370px;
    display: flex;
    flex-direction: column
}
</style>